import React, { useState, useEffect } from "react";
import "./EquipmentList.css";
import profileIcon from "../../shared/assets/icons/profile.png";
import bellIcon from "../../shared/assets/icons/bell.png";
import moreIcon from "../../shared/assets/icons/actionIcon.png";
import actionIcon from "../../shared/assets/icons/actionIcon.png";
import searchIcon from "../../shared/assets/icons/search.png";
import addIcon from "../../shared/assets/icons/add.png";
import backIcon from "../../shared/assets/icons/back.png";
import rightIcon from "../../shared/assets/icons/rightIcon.png";
import downArrow from "../../shared/assets/icons/downArrow.png";
import filterIcon from "../../shared/assets/icons/filter.png";
import { useNavigate } from "react-router-dom";
import SearchInput from "../../components/SearchInput";
import EquipmentFilterModal from "../../components/EquipmentFilterModal";
import { equipmentService } from "./services/equipmentService";
import DataTableGrid from "../../shared/components/DataTableGrid";
import { getPaginationTotalCount } from "../../shared/utils/paginationHelper";
import { Defualt_page_count } from "../../shared/constants/uiConstants";
import HeaderNav from "../../shared/components/HeaderNav";
import { LuFilter } from "react-icons/lu";
import { IoMdArrowBack } from "react-icons/io";
import { IoArrowUndoOutline } from "react-icons/io5";
import MainLoader from "../../shared/components/MainLoader";
import MobileFooterNav from "../../shared/components/MobileFooterNav";

const EquipmentList = () => {
  const [addresses, setAddresses] = useState([]);
  const [equipmentDatas, setEquipmentDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [activeFilters, setActiveFilters] = useState({
    productId: "",
    productName: "",
    makeId: "",
    makeName: "",
    modelId: "",
    modelName: "",
  });
  const itemsPerPage = 10;
  const getContractTypeLabel = (contractCode) => {
    const contractMap = {
      0: "PAID",
      1: "UNDER WARRANTY",
      3: "AMC",
    };
    return contractMap[contractCode] !== undefined
      ? contractMap[contractCode]
      : "N/A";
  };
  const fetchEquipmentDatas = async (page = 1) => {
    setLoading(true);
    setError(null);
    try {
      const filters = {
        sortField,
        searchQuery,
        productId: activeFilters.productId,
        makeId: activeFilters.makeId,
        modelId: activeFilters.modelId,
      };

      const response = await equipmentService.fetchEquipment(
        page,
        itemsPerPage,
        filters
      );

      console.log("API Response:", response);

      // Your API returns: { data: { success: true, status_override: 0, data: [...] }, headers: ... }
      if (
        response &&
        response.data &&
        response.data.success &&
        Array.isArray(response.data.data)
      ) {
        const formattedData = response.data.data.map((item) => ({
          serialNo: item.serial_number || "N/A",
          name: item.serial_identifier || "N/A",
          category: item.category || "N/A",
          make: item.make || "N/A",
          model: item.model || "N/A",
          contractType: getContractTypeLabel(item.contract_type),
          address: item.address1 || "N/A",
          fullAddress:
            [item.address1, item.address2, item.city, item.state]
              .filter((addr) => addr && addr !== "" && addr !== ".")
              .join(", ") || "N/A",
          equipmentId: item.equipment_id,
          itemId: item.item_id,
          customerId: item.customer_id,
          companyName: item.company_name,
          createdAt: item.created_at,
          addressId: item.address_id,
          zipCode: item.zip_code,
          landmark: item.landmark,
          planFrom: item.plan_from,
          planTo: item.plan_to,
          startDate: item.start_date,
          validUpto: item.valid_upto,
          // For compatibility with existing code
          count: 1,
          products: [],
        }));

        console.log("Formatted Data:", formattedData);

        setEquipmentDatas(formattedData);

        // Try multiple ways to get total count for production compatibility
        let totalCount = 0;

        // Method 1: From response headers (works in development)
        if (response.headers) {
          const headerCount = getPaginationTotalCount(response.headers);
          if (headerCount > 0) {
            totalCount = headerCount;
          }
        }

        // Method 2: From response data properties (fallback for production)
        if (totalCount === 0 && response.data) {
          const dataCount =
            response.data.total_count ||
            response.data.total ||
            response.data.totalCount ||
            response.data.count;
          if (dataCount && dataCount > 0) {
            totalCount = parseInt(dataCount, 10);
          }
        }

        // Method 3: From top-level response properties
        if (totalCount === 0) {
          const responseCount =
            response.total_count ||
            response.total ||
            response.totalCount ||
            response.count;
          if (responseCount && responseCount > 0) {
            totalCount = parseInt(responseCount, 10);
          }
        }

        // Method 4: Calculate based on current data (last resort)
        if (totalCount === 0) {
          // If we got less than itemsPerPage items and we're on page 1, that's the total
          if (page === 1 && formattedData.length < itemsPerPage) {
            totalCount = formattedData.length;
          } else {
            // Estimate total based on current page and items received
            totalCount = (page - 1) * itemsPerPage + formattedData.length;
            // If we got a full page, assume there might be more
            if (formattedData.length === itemsPerPage) {
              totalCount += itemsPerPage; // Add another page worth to show next button
            }
          }
        }

        // Fallback to default if still zero
        if (totalCount === 0) {
          totalCount = Math.max(formattedData.length, Defualt_page_count);
        }

        console.log(
          "Total count determined:",
          totalCount,
          "from method:",
          response.headers && getPaginationTotalCount(response.headers) > 0
            ? "headers"
            : response.data &&
              (response.data.total_count ||
                response.data.total ||
                response.data.totalCount ||
                response.data.count)
            ? "response.data"
            : response.total_count ||
              response.total ||
              response.totalCount ||
              response.count
            ? "response"
            : "calculated"
        );

        setTotalItems(totalCount);
        // Set addresses, filtering out null/empty values
        const uniqueAddresses = Array.from(
          new Set(
            formattedData
              .map((item) => item.address)
              .filter((addr) => addr && addr !== "N/A")
          )
        );
        setAddresses(uniqueAddresses);

        console.log(
          "Equipment loaded successfully:",
          formattedData.length,
          "items"
        );
      } else {
        console.warn("Invalid response format:", response);
        setEquipmentDatas([]);
        setTotalItems(0);
        setAddresses([]);
      }
    } catch (error) {
      console.error("Error fetching equipment:", error);
      setError("Failed to load equipment. Please try again.");
      setEquipmentDatas([]);
      setTotalItems(0);
      setAddresses([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEquipmentDatas(currentPage);
  }, [currentPage, sortField, searchQuery, activeFilters]);

  const navigate = useNavigate();

  const [selectedProduct, setSelectedProduct] = useState(null);
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  // Debug logging for pagination issues
  useEffect(() => {
    console.log("Pagination Debug:", {
      totalItems,
      itemsPerPage,
      totalPages,
      currentPage,
      equipmentDataLength: equipmentDatas.length,
    });
  }, [totalItems, totalPages, currentPage, equipmentDatas.length]);

  const [activeTooltip, setActiveTooltip] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const handleTooltip = (item) => {
    // setActiveTooltip((prev) => (prev === item.serialNo ? null : item.serialNo));
  };

  const handleSort = (field) => {
    console.log("Sort clicked:", field);
    if (sortField === field) {
      // Toggle between field and -field
      setSortField(sortField.startsWith("-") ? field : `-${field}`);
    } else {
      // First click, set field without -
      setSortField(field);
    }
    setCurrentPage(1);
  };

  const getSortIcon = (field) => {
    if (sortField === field) return " ↑";
    if (sortField === `-${field}`) return " ↓";
    return "";
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [isMobile, setIsMobile] = useState(false);
  const [currentScreen, setCurrentScreen] = useState("home");
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [expandedBrands, setExpandedBrands] = useState({});
  const [selectedAddress, setSelectedAddress] = useState("");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleEquipmentClick = (equipment) => {
    // setSelectedEquipment(equipment);
    // setCurrentScreen("details");
  };

  const handleBack = () => {
    setCurrentScreen("home");
    setSelectedProduct(null);
  };

  const toggleBrandExpand = (brand) => {
    setExpandedBrands((prev) => ({
      ...prev,
      [brand]: !prev[brand],
    }));
  };

  const searchTimerRef = React.useRef(null);
  const handleSearchChange = (e) => {
    const val = e.target.value;
    setSearchInput(val);
    clearTimeout(searchTimerRef.current);
    searchTimerRef.current = setTimeout(() => {
      setSearchQuery(val);
      setCurrentPage(1);
    }, 500);
  };

  const handleApplyFilters = async (filters) => {
    setActiveFilters(filters);
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    setActiveFilters({
      productId: "",
      productName: "",
      makeId: "",
      makeName: "",
      modelId: "",
      modelName: "",
    });
    setCurrentPage(1);
  };

  const getActiveFilterCount = () => {
    let count = 0;
    if (activeFilters.productId) count++;
    if (activeFilters.makeId) count++;
    if (activeFilters.modelId) count++;
    return count;
  };

  const hasActiveFilters = searchQuery || getActiveFilterCount() > 0;

  if (isMobile && currentScreen === "details") {
    return (
      <div className="mobile-container">
        <header className="mobile-header">
          <button className="back-button" onClick={handleBack}>
            <img
              src={backIcon}
              alt="Back"
              className="icon mobile-details-icon"
            />
          </button>
          <h1 className="mobile-title">{selectedEquipment.name}</h1>
          <div className="header-icons">
            <img
              src={bellIcon}
              alt="Notifications"
              className="icon mobile-details-icon"
            />
          </div>
        </header>
        <div className="equipment-details">
          {selectedEquipment.products.map((product, index) => (
            <div key={index} className="product-card mobile-product-card">
              <div className="product-name mobile-product-name">
                <p>{product.product_name}</p>
              </div>
              <div className="make mobile-make-label">
                <p>Make</p>
              </div>
              {product.models.map((model, modelIndex) => (
                <div key={modelIndex} className="model-item mobile-model-item">
                  <div
                    className="model-header mobile-model-header"
                    onClick={() => toggleBrandExpand(model.brand)}
                  >
                    <span className="brand-name mobile-brand-name">
                      {model.brand}
                    </span>
                    <img
                      src={downArrow}
                      alt="Expand"
                      className={`expand-icon mobile-expand-icon ${
                        expandedBrands[model.brand] ? "rotated" : ""
                      }`}
                    />
                  </div>
                  {expandedBrands[model.brand] && (
                    <div className="model-info mobile-model-info">
                      <div className="mobile-model-info-header">
                        <p className="mobile-model-info-left">Model</p>
                        <p className="mobile-model-info-right">Serial Number</p>
                      </div>
                      {model.models.map((subModel, subModelIndex) => (
                        <div key={subModelIndex} className="mobile-sub-model">
                          <div className="mobile-sub-model-container">
                            <p className="mobile-sub-model-left">
                              {subModel.model_name}
                            </p>
                            <p className="mobile-sub-model-right">
                              {subModel.serial}
                            </p>
                          </div>
                          {subModelIndex < model.models.length - 1 && (
                            <hr className="mobile-divider" />
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                  {modelIndex < product.models.length - 1 && (
                    <hr className="mobile-divider" />
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!isMobile && currentScreen === "details") {
    return (
      <div className="equipment-list-container">
        <header className="major-header">
          <h1 className="app-title"></h1>
          <div className="header-icons">
            <img
              src={bellIcon}
              alt="Notifications"
              className="notification-icon"
            />
            <img
              src={profileIcon}
              alt="Profile"
              className="icon profile-icon"
            />
          </div>
        </header>
        <div className="header desktop-header">
          <div className="desktop-header-left">
            <button
              className="back-button desktop-back-button"
              onClick={handleBack}
            >
              <img src={backIcon} alt="Back" className="icon back-icon" />
            </button>
            <h2 className="title desktop-details-title">
              {selectedEquipment.name}
            </h2>
          </div>
          <div className="filters desktop-filters">
            <button className="search-button">
              <img src={searchIcon} alt="Filter" className="icon" />
            </button>
            <button
              className="add-button desktop-add-button"
              onClick={() => navigate("/equipment")}
            >
              <img src={addIcon} alt="Add" className="icon" />
            </button>
          </div>
        </div>
        <div className="equipment-details equipment-details-container">
          <div className="product-list product-list-container">
            <h3 className="product-list-title">Products</h3>
            {selectedEquipment.products.map((product, index) => (
              <div
                key={index}
                className={`product-card product-card-clickable ${
                  selectedProduct === product ? "selected" : ""
                }`}
                onClick={() => setSelectedProduct(product)}
              >
                <div className="product-name">
                  <p>{product.product_name}</p>
                </div>
              </div>
            ))}
          </div>
          {selectedProduct && (
            <div className="product-details product-details-container">
              <h3 className="product-details-title">
                {selectedProduct.productName}
              </h3>
              {selectedProduct.models.map((model, modelIndex) => (
                <div key={modelIndex} className="model-item">
                  <div
                    className="model-header model-header-container"
                    onClick={() => toggleBrandExpand(model.brand)}
                  >
                    <span className="brand-name brand-name-style">
                      {model.brand}
                    </span>
                    <img
                      src={downArrow}
                      alt="Expand"
                      className={`expand-icon expand-icon-style ${
                        expandedBrands[model.brand] ? "rotated" : ""
                      }`}
                    />
                  </div>
                  {expandedBrands[model.brand] && (
                    <div className="model-info">
                      <div className="model-info-header">
                        <p>Model</p>
                        <p>Serial Number</p>
                      </div>
                      {model.models.map((subModel, subModelIndex) => (
                        <div key={subModelIndex} className="sub-model-item">
                          <div className="sub-model-container">
                            <p>{subModel.model_name}</p>
                            <p>{subModel.serial}</p>
                          </div>
                          {subModelIndex < model.models.length - 1 && (
                            <hr className="divider divider-style" />
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                  {modelIndex < selectedProduct.models.length - 1 && (
                    <hr className="divider divider-style" />
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className="task-list-container">
      {/*Greeting Header */}
      <HeaderNav profileIcon={profileIcon} />
      {/* Mobile Header */}
      <header className="mobile-header">
        <div className="header-left" onClick={() => navigate("/dashboard")}>
          <IoArrowUndoOutline color="black" size={25} alt="Back" />
        </div>
        <h2
          style={{
            fontSize: "16px",
            fontFamily: "lato, sans-serif",
            marginLeft: "10px",
            color: "#000",
          }}
        >
          Equipments
        </h2>
        <div className="header-right" style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <div style={{ position: "relative", cursor: "pointer" }} onClick={() => setIsFilterModalOpen(true)}>
            <LuFilter size={20} />
            {getActiveFilterCount() > 0 && (
              <span className="filter-indicator">{getActiveFilterCount()}</span>
            )}
          </div>
          <button
            className="mobile_task_add-button"
            onClick={() => navigate("/equipment")}
          >
            <img src={addIcon} alt="Add" />
          </button>
        </div>
      </header>


      <div className="mobile-search-bar">
        <SearchInput
          value={searchInput}
          onChange={handleSearchChange}
          placeholder="Search Equipment"
          width="100%"
        />
      </div>

      {/* Filters Section */}
      <div className="header">
        <h2 className="page-title">Equipments</h2>
        <div className="filters">
          <SearchInput
            value={searchInput}
            onChange={handleSearchChange}
            placeholder="Search equipment..."
            width="250px"
          />
          <button
            className="search-button filter-button-container"
            onClick={() => setIsFilterModalOpen(true)}
          >
            <LuFilter alt="Filter" size={16} color="white" />
            {/* <img src={filterIcon} alt="Filter" /> */}
            {getActiveFilterCount() > 0 && (
              <span className="filter-indicator">{getActiveFilterCount()}</span>
            )}
          </button>
          <button className="add-button" onClick={() => navigate("/equipment")}>
            <img src={addIcon} alt="Add" />
          </button>
        </div>
      </div>

      {/* Desktop Table - Wrapped in scrollable container */}
      <div className="task-table-container">
        {loading ? (
          <MainLoader />
        ) : error ? (
          <div className="error-container">
            <div className="error-box">
              <div className="error-icon">📭</div>
              <div className="error-text">No Equipment Available</div>
            </div>
          </div>
        ) : equipmentDatas.length === 0 ? (
          <div className="error-container">
            <div className="error-box">
              <div className="error-icon">{hasActiveFilters ? '🔍' : '📭'}</div>
              <div className="error-text">{hasActiveFilters ? 'No equipment match your filters' : 'No Equipment Available'}</div>
            </div>
          </div>
        ) : (
          <DataTableGrid
            items={equipmentDatas.filter(
              (item) => !selectedAddress || item.address === selectedAddress
            )}
            loading={loading}
            error={error}
            emptyMessage="No equipment found"
            onSort={handleSort}
            sortField={sortField}
            getSortIcon={getSortIcon}
            columns={[
              { key: "serialNo", title: "Serial No", sortKey: "serial_number" },
              { key: "name", title: "Equipment", sortKey: "serial_identifier" },
              {
                key: "contractType",
                title: "Contract Type",
                sortKey: "contract_type",
              },
            ]}
          />
        )}
      </div>

      {/* Desktop Pagination */}
      {!isMobile && totalPages > 1 && (
        <div className="pagination">
          <button
            className="page-button"
            onClick={handlePreviousPage}
            disabled={currentPage === 1 || loading}
          >
            {"<"}
          </button>
          {Array.from({ length: Math.min(totalPages, 10) }, (_, index) => {
            let pageNumber;
            if (totalPages <= 10) {
              pageNumber = index + 1;
            } else {
              const start = Math.max(1, currentPage - 5);
              const end = Math.min(totalPages, start + 9);
              pageNumber = start + index;
              if (pageNumber > end) return null;
            }
            return (
              <button
                key={pageNumber}
                className={`page-number-button ${
                  currentPage === pageNumber ? "active" : ""
                }`}
                onClick={() => handlePageClick(pageNumber)}
                disabled={loading}
              >
                {pageNumber}
              </button>
            );
          }).filter(Boolean)}
          <button
            className="page-button"
            onClick={handleNextPage}
            disabled={currentPage === totalPages || loading}
          >
            {">"}
          </button>
        </div>
      )}
      {isMobile && <div style={{ marginTop: 10 }}></div>}
      <div
        className="task-content-container"
        style={{
          display: isMobile ? "flex" : "none",
          height: isMobile ? "calc(100vh - 200px)" : "auto",
          overflowY: isMobile ? "scroll" : "visible",
          WebkitOverflowScrolling: "touch",
          flexDirection: "column",
          gap: "10px",
          padding: "10px",
          paddingBottom: "80px",
          background: "#F6F8FC",
        }}
      >
        {loading ? (
          <MainLoader />
        ) : error ? (
          <div className="mobile-empty-state">
            <div className="mobile-empty-icon">📭</div>
            <div className="mobile-empty-text">No Equipment Available</div>
          </div>
        ) : equipmentDatas.length === 0 ? (
          <div className="mobile-empty-state">
            <div className="mobile-empty-icon">{hasActiveFilters ? '🔍' : '📭'}</div>
            <div className="mobile-empty-text">{hasActiveFilters ? 'No equipment match your filters' : 'No Equipment Available'}</div>
          </div>
        ) : (
          equipmentDatas
            .filter(
              (equipment) =>
                !selectedAddress || equipment.address === selectedAddress
            )
            .map((equipment, index) => (
              <div
                key={`${currentPage}-${equipment.serialNo}-${index}`}
                className="task-card-new"
                onClick={() => handleEquipmentClick(equipment)}
              >
                <div className="task-top-row">
                  <span className="task-date">{equipment.serialNo}</span>
                  <span
                    className={`task-status status-${equipment.contractType
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    {equipment.contractType}
                  </span>
                </div>
                <div className="task-main-row">
                  <div className="task-details">
                    <h3 className="task-equipment">{equipment.name}</h3>
                    <p className="task-company">
                      {equipment.category} | {equipment.make}
                    </p>
                    <p className="task-warranty">{equipment.model}</p>
                  </div>
                </div>
              </div>
            ))
        )}
      </div>

      <EquipmentFilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        onApplyFilters={handleApplyFilters}
        onClearFilters={handleClearFilters}
        initialFilters={activeFilters}
      />
      <MobileFooterNav />
    </div>
  );
};

export default EquipmentList;
